// The contributions of the enabled features (ADR-0027 D9).
//
// `virtual:septima-features` is the list of the feature files that the
// Feature Manifest enables (`@septima/feature-core/vite`). The router builds
// its routes from `routesFor`, and `frontends.ts` builds the sidebar tables
// from `navFor`. Neither file holds a route or a sidebar row of its own.
//
// In Vitest the module is a stub that enables every feature
// (`src/test/septima-features-stub.ts`).
import {
    ENABLED,
    GRANTS_ALL_SEATS,
    MANIFEST_HASH,
    SEAT_OF,
    WEB_FEATURES,
} from 'virtual:septima-features';
import type { FrontendKey } from '@septima/contract';
import type { AppNav, AppRoute, AppWebFeature, RouteLayout } from '@/features/kit';

/** The feature files of the build, in path order. */
export const APP_FEATURES = WEB_FEATURES as readonly AppWebFeature[];

export { ENABLED, GRANTS_ALL_SEATS, MANIFEST_HASH, SEAT_OF };

/** A contribution with the id of the feature that made it. */
export type Contributed<T> = T & { readonly feature: string };

/** The routes of a layout, from each enabled feature. */
export function routesFor(layout: RouteLayout): Contributed<AppRoute>[] {
    return APP_FEATURES.flatMap((f) =>
        (f.routes ?? []).filter((r) => r.frontend === layout).map((r) => ({ ...r, feature: f.id })),
    );
}

/** The sidebar rows of a staff view, from each enabled feature, sorted by `order`. */
export function navFor(frontend: FrontendKey): Contributed<AppNav>[] {
    return APP_FEATURES.flatMap((f) =>
        (f.nav ?? []).filter((n) => n.frontend === frontend).map((n) => ({ ...n, feature: f.id })),
    ).sort((a, b) => a.order - b.order);
}
